module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Db-Fb-Ge-Hc-Ia-outside.70cc02ae.png";